module.exports = __webpack_public_path__ + "img/undefined.40ced7f6.gif";